import { useQuery } from 'react-query';

import api from '@root/api/newApi';

function useCollections() {
  return useQuery(
    'shopify-collections',
    () => api.shopify.getCollections(),
  );
}

export default useCollections;
